module.exports = __webpack_public_path__ + "img/TZS09688.5f42e9dc.jpeg";